import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardHeader,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,

} from 'mdb-react-ui-kit';
import Helper from '../../Helper';

import moment from 'moment';
import Alert from './dialog'
import Search from './search'
import PieChart from './PieChart'

import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';


const Component = () => {
  const alert = useRef();
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const setError = (message, ismessage) => (ismessage ? alert.current.showmessage(message) : alert.current.showerror(message));
  const [transportJobListExpense, setTransportJobListExpense] = useState([]);
  const [transportJobList, setTransportJobList] = useState([]);
  const [iconsActive, setIconsActive] = useState('income');

  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }


  }, []);

  const fetchTransportJobList_excel = async (dateFrom, dateTo) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransport_Job_AccountSummary_export`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo }),

      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `job_summary_${dateFrom}_to_${dateTo}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to export summary');
      }
    } catch (err) {
      setError('An error occurred while fexport summary.');
    }
  };


  const fetchTransportJobList = async (dateFrom, dateTo) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransport_Job_AccountSummary`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transport_account);
        setTransportJobListExpense(data.transport_expense);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };

  let numOr0 = n => isNaN(n) ? 0 : n
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }

    setIconsActive(value);
  };

  return (<>

    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">

            <MDBCardBody>
              <MDBRow className='mb-3'>
                <MDBCol md='12'>
                  <Search search={fetchTransportJobList} exportexcel={fetchTransportJobList_excel} disablesearch={true} />
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
                <MDBCol md='4'>
                  <MDBCard>
                    <MDBCardBody>
                      <MDBCardTitle>สรุปรายรับ</MDBCardTitle>
                      <MDBCardText className='text-success fw-bold' >
                        <MDBRow><MDBCol md='4'>อนุมัติ</MDBCol><MDBCol md='8'>{Helper.formatnumber(transportJobList.filter(el => el.statusid == 3 && el.totalamount != null).map(el => el.totalamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท</MDBCol></MDBRow>
                        <MDBRow><MDBCol md='4'>ทั้งหมด</MDBCol><MDBCol md='8'>{Helper.formatnumber(transportJobList.filter(el => el.totalamount != null).map(el => el.totalamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท</MDBCol></MDBRow>
                      </MDBCardText>
                      <PieChart
                        size={150}
                        thickness={26}
                        data={[
                          {
                            label: 'ค่าขนส่ง',
                            color: '#3b71ca',
                            value: transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.shipping)), 0),
                            formattedValue: Helper.formatnumber(transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.shipping)), 0)),
                          },
                          {
                            label: 'ชิปปิ้ง',
                            color: '#8fb4e3',
                            value: transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.servicecharge)), 0),
                            formattedValue: Helper.formatnumber(transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.servicecharge)), 0)),
                          },
                          {
                            label: 'อื่นๆ',
                            color: '#aab2c5',
                            value: transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.other)) + parseFloat(numOr0(el.officer)), 0),
                            formattedValue: Helper.formatnumber(transportJobList.filter(el => el.totalamount != null).reduce((a, el) => a + parseFloat(numOr0(el.other)) + parseFloat(numOr0(el.officer)), 0)),
                          },
                        ]}
                      />
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
                <MDBCol md='2'>
                  <MDBCard>
                    <MDBCardBody>
                      <MDBCardTitle>สรุปรายจ่าย</MDBCardTitle>
                      <MDBCardText className='text-danger fw-bold' >
                        <MDBRow><MDBCol md='4'>อนุมัติ</MDBCol><MDBCol md='8'>{Helper.formatnumber(transportJobListExpense.filter(el => el.statusid == 3 && el.totalamount != null).map(el => el.totalamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท</MDBCol></MDBRow>
                        <MDBRow><MDBCol md='4'>ทั้งหมด</MDBCol><MDBCol md='8'>{Helper.formatnumber(transportJobListExpense.filter(el => el.totalamount != null).map(el => el.totalamount).reduce((a, b) => parseFloat(numOr0(a)) + parseFloat(numOr0(b)), 0))} บาท</MDBCol></MDBRow>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
                <MDBCol md='12'>
                  <MDBTabs className='mb-3'>
                    <MDBTabsItem>
                      <MDBTabsLink onClick={() => handleIconsClick('income')} active={iconsActive === 'income'}>
                        <MDBIcon fas icon='chart-pie' className='me-2' /> รายรับ
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink onClick={() => handleIconsClick('outcome')} active={iconsActive === 'outcome'}>
                        <MDBIcon fas icon='chart-line' className='me-2' /> รายจ่าย
                      </MDBTabsLink>
                    </MDBTabsItem>
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={iconsActive === 'income'} >
                      <MDBTable align='middle' style={{zoom:"80%" }}>
                        <MDBTableHead>
                          <tr>
                            <th scope='col'>สถานะ</th>
                            <th scope='col'>BL</th>
                            <th scope='col'>วันที่</th>
                            <th scope='col'>ชื่อบิล</th>
                            <th scope='col'>ลูกค้า</th>
                            <th scope='col'>งาน</th>
                            <th scope='col'>วันที่วิ่งงาน</th>
                            <th scope='col'>ปลายทาง</th>
                            <th scope='col'>ขนาดตู้</th>
                            <th scope='col'>เบอร์ตู้</th>
                            <th scope='col'>คนรถ</th>
                            <th scope='col'>ทะเบียน</th>
                            <th scope='col'>จ่าย</th>
                            <th scope='col' style={{ textAlign: "right" }}>ชิปปิ้ง</th>
                            <th scope='col' style={{ textAlign: "right" }}>vat</th>
                            <th scope='col' style={{ textAlign: "right" }}>หัก ณ ที่จ่าย</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าขนส่ง</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่านายตรวจ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าอื่นๆ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ทั้งหมด</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {transportJobList.map((row, i) => (<tr key={i}>
                            <td>{row.status}</td>
                            <td>{row.bl}</td>
                            <td>{moment(row.billdateobj).format("DD/MM/YYYY")}</td>
                            <td>{row.name}</td>
                            <td>{row.customername}</td>
                            <td>{row.jobname}</td>
                            <td>{moment(row.jobdateobj).format("DD/MM/YYYY")}</td>
                            <td>{row.destination}</td>
                            <td>{row.boxsize}</td>
                            <td>{row.boxno}</td>
                            <td>{row.driver}</td>
                            <td>{row.lcplate}</td>
                            <td>{row.paidby}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.servicecharge)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.vat)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.whtamount)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.shipping)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.officer)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.other)}</td>
                            <th style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalamount)}</th>
                          </tr>))}

                        </MDBTableBody>
                      </MDBTable>

                    </MDBTabsPane>
                    <MDBTabsPane open={iconsActive === 'outcome'}>

                      <MDBTable align='middle' style={{zoom:"80%"}}>
                        <MDBTableHead>
                        <tr>
                            <th scope='col'>สถานะ</th>
                            <th scope='col'>BL</th>
                            <th scope='col'>วันที่</th>
                            <th scope='col'>ชื่อบิล</th>
                            <th scope='col'>ชื่อบิล (ค่าใช้จ่าย)</th>
                            <th scope='col'>ลูกค้า</th>
                            <th scope='col'>งาน</th>
                            <th scope='col'>วันที่วิ่งงาน</th>
                            <th scope='col'>ปลายทาง</th>
                            <th scope='col'>ขนาดตู้</th>
                            <th scope='col'>เบอร์ตู้</th>
                            <th scope='col'>คนรถ</th>
                            <th scope='col'>ทะเบียน</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าเที่ยว</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าแรง</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่านายตรวจ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าทางด่วน</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าปะยาง</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าฝากตู้</th>
                            <th scope='col' style={{ textAlign: "right" }}>ล่วงเวลา</th>
                            <th scope='col' style={{ textAlign: "right" }}>ซ่อมรถ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าน้ำมัน</th>
                            <th scope='col' style={{ textAlign: "right" }}>ค่าอื่นๆ</th>
                            <th scope='col' style={{ textAlign: "right" }}>ทั้งหมด</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {transportJobListExpense.map((row, i) => (<tr key={i}>
                            <td>{row.status}</td>
                            <td>{row.bl}</td>
                            <td>{moment(row.billdateobj).format("DD/MM/YYYY")}</td>
                            <td>{row.name}</td>
                            <td>{row.expense_name}</td>
                            <td>{row.customername}</td>
                            <td>{row.jobname}</td>
                             <td>{moment(row.jobdateobj).format("DD/MM/YYYY")}</td>
                            <td>{row.destination}</td>
                            <td>{row.boxsize}</td>
                            <td>{row.boxno}</td>
                            <td>{row.driver}</td>
                            <td>{row.lcplate}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.travel)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.service)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.officer)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.toll)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.tire)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.boxdeposit)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.ot)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.fixservice)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.gas)}</td>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(row.other)}</td>
                            <th style={{ textAlign: "right" }}>{Helper.formatnumber(row.totalamount)}</th>
                          </tr>))}

                        </MDBTableBody>
                      </MDBTable>
                    </MDBTabsPane>

                  </MDBTabsContent>

                </MDBCol>
              </MDBRow>
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>);
};

export default Component;
